<!-- src/plugins/confirm/ConfirmModal.vue -->
<template>
  <h-dialog title="" v-model="visible" @on-cancel="close" @on-ok="confirm" width="424px" align-center
            header-class="message-header">
    <template #header>
      <div class="title">
        <el-icon size="20" style="margin-right: 12px" :color="iconColor">
          <WarningFilled v-if="type === 'warning'" />
          <SuccessFilled v-if="type === 'success'" />
          <CircleCloseFilled v-if="type === 'danger'" />
          <InfoFilled v-if="type === 'info'" />
        </el-icon>
        <div class="text">{{ title }}</div>
        <el-icon @click="close" style="margin-left: auto">
          <Close />
        </el-icon>
      </div>
    </template>
    <div class="dialog-content" v-if="message">
      <div class="message">
        <component :is="message"></component>
      </div>
    </div>
    <span v-else></span>
    <template #footer>
      <el-button v-if="cancelText" @click="close">{{ cancelText }}</el-button>
      <el-button v-if="confirmText" @click="confirm" type="primary">{{ confirmText }}</el-button>
    </template>
  </h-dialog>
</template>

<script setup>
import { ref, computed, h } from 'vue'
import { HDialog } from '@/components/index.js'
import { WarningFilled, Close, SuccessFilled, CircleCloseFilled, InfoFilled } from '@element-plus/icons-vue'

const visible = ref(false)
const title = ref('')
const message = ref()
const confirmText = ref()
const cancelText = ref()
const type = ref('warning')
let _resolve, _reject

const iconColor = computed(() => {
  if (type.value === 'warning') return '#FF7A00'
  if (type.value === 'success') return '#44D941'
  if (type.value === 'danger') return '#FF4D4F'
  if (type.value === 'info') return '#9FA1A3'
  return '#FF7A00'
})

/**
 * @param {string|VNODE} msg - 弹窗内容
 * @param {string} dlgTitle - 弹窗标题
 * @param {object} opts - 其他选项
 * @param {string?} opts.confirmText - 确认按钮文字
 * @param {string?} opts.cancelText - 取消按钮文字
 * @param {'success'|'warning'|'danger'|'info'} opts.type - 类型（影响样式）
 */
const show = (msg, dlgTitle = '提示', opts = {}) => {
  message.value = typeof msg === 'string' ? h('span', msg) : msg
  title.value = dlgTitle
  confirmText.value = opts.confirmText
  cancelText.value = opts.cancelText
  type.value = opts.type || 'warning'

  visible.value = true

  return new Promise((resolve, reject) => {
    _resolve = resolve
    _reject = reject
  })
}

const confirm = () => {
  visible.value = false
  _resolve?.(true)
}

const close = () => {
  visible.value = false
  _reject?.(false)
}

defineExpose({ show })  // 让父组件可通过 ref 调用 show
</script>

<style lang="scss" scoped>
.title {
  display: flex;
  align-items: center;
  font-size: 16px;
}

.dialog-content {
  padding-bottom: 16px;

  .message {
    padding-left: 34px;
    word-break: break-all;
  }
}

:deep(.el-dialog__header) {
  padding-bottom: 12px;
}
</style>
